function timePartsToMinutes(t: string): number {
    const [h, m] = t.split(':').map(Number);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return NaN;
    return h * 60 + m;
}

/**
 * Validates publication date/time fields for CMS horoscope AI panels.
 */
export function cmsHoroscopeGeneratorFieldError(pubDateFrom: string, pubDateTo: string, timeFrom: string, timeTo: string): string | null {
    if (!pubDateFrom || !pubDateTo) {
        return 'Uzupełnij zakres dat publikacji (od i do).';
    }
    if (pubDateFrom > pubDateTo) {
        return 'Zakres dat publikacji: pierwsza data nie może być późniejsza niż druga.';
    }
    const fm = timePartsToMinutes(timeFrom);
    const tm = timePartsToMinutes(timeTo);
    if (!Number.isFinite(fm) || !Number.isFinite(tm)) {
        return 'Niepoprawny format godzin publikacji.';
    }
    if (fm > tm) {
        return 'Godziny publikacji: pierwsza godzina nie może być późniejsza niż druga.';
    }
    return null;
}

export function mergeHoroscopeAiPanelErrors(tabRangeError: string | null, generatorFieldError: string | null): string | null {
    return tabRangeError || generatorFieldError || null;
}
